import { render, staticRenderFns } from "./CertificationSection.vue?vue&type=template&id=1d447e20&scoped=true"
import script from "./CertificationSection.vue?vue&type=script&lang=js"
export * from "./CertificationSection.vue?vue&type=script&lang=js"
import style0 from "./CertificationSection.vue?vue&type=style&index=0&id=1d447e20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d447e20",
  null
  
)

export default component.exports